<template>
  <div>
    <div class="about-banner">
      <img src="@/assets/images/website/about/about-banner.png" />
      <div>
        <h3>为用户增值 创共赢生态</h3>
      </div>
    </div>
    <div class="about-introduce">
      <div class="website-container flex">
        <div class="left">
          <h3>平台介绍</h3>
        </div>
        <div class="right">
          <p>
            中色科技隶属于中铝集团，是我国有色金属加工领域唯一一家专业设计科研机构，扎根行业服务60年，对行业和企业有全面了解和深层认识，拥有国家级企业技术中心，专业全、人才多，具有丰富的工程建设经验和丰硕的专业技术成果。中色科技成立了智能技术公司，专门从事中色云工业互联网平台建设工作，在桂卫华和谢建新院士指导下，与中南大学、北京科技大学、联通、上海优也、蓝卓数科等高校与企业联合，完成平台搭建，开发了生产数据可视化、智慧监诊等应用。
          </p>
          <p>
            中色云工业互联网平台的建设和运营，将引导形成行业共享新生态，提高行业整体竞争力，助力行业高质量发展，加快行业绿色化转型，推动行业产业链协同。平台通过对企业人、机、物、系统进行全面互联，提供基于大数据、云计算等技术的全方位设备管理、生产控制、工艺管控、质量管理、安环监控、能源管理等服务，为企业技术创新、生产管控、设备运行、质量提升、能耗优化、上下游资源对接提供支撑。
          </p>
        </div>
      </div>
    </div>
    <div class="about-mission">
      <img src="@/assets/images/website/about/Building.jpg" />
      <div class="website-container flex">
        <div class="left">
          <h3>愿景使命</h3>
        </div>
        <div class="right">
          <div class="mission-item" v-for="item in missionList" :key="item.title">
            <div class="title">{{ item.title }}</div>
            <div class="text">{{ item.text }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="about-connotation">
      <div class="website-container flex">
        <div class="left">
          <h3>品牌内涵</h3>
        </div>
        <div class="right">
          <img src="@/assets/images/website/about/logo.png" />
          <p>
            中色云LOGO，由中色科技股份有限公司将拉伸和卷曲的铝卷与云的形状结合精心设计而成。该设计表明了有色金属加工与工业互联网两个概念，体现了平台为有色金属加工行业提供工业云服务的理念。
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      missionList: [
        {
          title: "愿景",
          text: "建设国际领先的以咨询设计为引领的有色金属加工工程技术公司",
        },
        {
          title: "使命",
          text: "为国内有色金属加工行业提供数字化转型一体化方案",
        },
        {
          title: "个性",
          text: "真诚、进化   开放、创新   勤奋、弘毅",
        },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.about-banner {
  width: 100%;
  height: 412px;
  position: relative;

  img {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }

  div {
    width: 1280px;
    margin: 0 auto;
    height: 100%;
    display: flex;
    align-items: center;
    position: relative;

    h3 {
      font-family: PingFangSC-Medium;
      font-size: 54px;
      color: #ffffff;
      font-weight: 500;
    }
  }
}

.about-introduce {
  width: 100%;
  height: 420px;
  padding-top: 90px;
  background: #ffffff;
  display: flex;

  .left {
    width: 292px;

    h3 {
      font-family: MicrosoftYaHei;
      font-size: 38px;
      color: #000000;
      letter-spacing: 0;
      text-align: center;
      font-weight: 400;
      text-align: left;
    }
  }

  .right {
    flex: 1;

    p {
      font-family: MicrosoftYaHei;
      font-size: 16px;
      color: #333333;
      letter-spacing: 0;
      text-align: justify;
      line-height: 28px;
      font-weight: 400;
      margin-bottom: 30px;
    }
  }
}

.about-mission {
  width: 100%;
  height: 495px;
  padding-top: 90px;
  background: #edf1fa;
  display: flex;
  position: relative;

  img {
    width: 915px;
    height: 496px;
    position: absolute;
    top: 0;
    right: 0;
  }

  .left {
    width: 292px;

    h3 {
      font-family: MicrosoftYaHei;
      font-size: 38px;
      color: #000000;
      letter-spacing: 0;
      text-align: center;
      font-weight: 400;
      text-align: left;
    }
  }

  .right {
    flex: 1;
    position: relative;

    .mission-item {
      margin-bottom: 50px;

      .title {
        font-family: MicrosoftYaHei-Bold;
        font-size: 24px;
        color: #0a1325;
        font-weight: 700;
        margin-bottom: 14px;
      }

      .text {
        font-family: MicrosoftYaHeiLight;
        font-size: 16px;
        color: #0a1325;
        text-align: justify;
        font-weight: 200;
      }
    }
  }
}

.about-connotation {
  width: 100%;
  height: 300px;
  padding-top: 90px;
  background: #ffffff;
  display: flex;

  .left {
    width: 292px;

    h3 {
      font-family: MicrosoftYaHei;
      font-size: 38px;
      color: #000000;
      letter-spacing: 0;
      text-align: center;
      font-weight: 400;
      text-align: left;
    }
  }

  .right {
    flex: 1;

    img {
      width: 290px;
      height: 72px;
      object-fit: contain;
      margin-bottom: 21px;
    }

    p {
      font-family: MicrosoftYaHei;
      font-size: 16px;
      color: #333333;
      letter-spacing: 0;
      text-align: justify;
      line-height: 28px;
      font-weight: 400;
    }
  }
}
</style>
